import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { SummerInternshipsHeadingRoutingModule } from './summer-internships-heading-routing.module';
import { SummerInternshipsHeadingListComponent } from './summer-internships-heading-list/summer-internships-heading-list.component';
import { SummerInternshipsHeadingCreateComponent } from './summer-internships-heading-create/summer-internships-heading-create.component';

@NgModule({
  declarations: [SummerInternshipsHeadingListComponent, SummerInternshipsHeadingCreateComponent],
  imports: [
    CommonModule,
    SummerInternshipsHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class SummerInternshipsHeadingModule { }
